import {
  House, Sparkle, UsersThree, BookOpen, TShirt, Globe, PenNib, Brain,
  FilmSlate, TextT, SquaresFour, VideoCamera, Waveform, Translate, Scissors,
  Image as ImageIcon, MusicNotes, ShareNetwork, PaperPlaneTilt, CalendarBlank,
  ChartLineUp, TrendUp, CurrencyDollar, Gauge, Stack, ShieldCheck, Crosshair as Radar, Fingerprint,
  Handshake, Package, BellRinging, Gear, BookBookmark, Buildings, HardDrives, Flask, WaveSine,
  UserCircle, TrashSimple, ListMagnifyingGlass, Notebook, Cpu, GameController, Images, DeviceMobile,
} from "@phosphor-icons/react";

export const NAV = [
  { section: "Studio", items: [
    { to: "/", label: "Home", icon: House },
    { to: "/studio-bible", label: "Studio Bible", icon: BookBookmark },
    { to: "/studios", label: "All Studios", icon: Buildings },
  ]},
  { section: "Create", items: [
    { to: "/characters", label: "Character Studio", icon: UsersThree },
    { to: "/bible", label: "Character Bible", icon: BookOpen },
    { to: "/outfits", label: "Outfits & Props", icon: TShirt },
    { to: "/worlds", label: "World Builder", icon: Globe },
    { to: "/story", label: "Story AI", icon: PenNib },
    { to: "/canon", label: "Story Canon", icon: Brain },
    { to: "/memory", label: "AI Memory", icon: Notebook },
    { to: "/assets", label: "Media Library", icon: Images },
  ]},
  { section: "Production", items: [
    { to: "/episodes", label: "Episode Studio", icon: FilmSlate },
    { to: "/script", label: "Script Editor", icon: TextT },
    { to: "/storyboard", label: "Storyboard", icon: SquaresFour },
    { to: "/director", label: "AI Director", icon: VideoCamera },
    { to: "/render", label: "Render & Media", icon: VideoCamera },
    { to: "/timeline", label: "Timeline Editor", icon: Waveform },
    { to: "/voice", label: "Voice Studio", icon: Waveform },
  ]},
  { section: "Game Studio", items: [
    { to: "/games", label: "Game Projects", icon: GameController },
  ]},
  { section: "App Studio", items: [
    { to: "/apps", label: "App Projects", icon: DeviceMobile },
    { to: "/campaigns/pinpilot", label: "PinPilot Campaigns", icon: FilmSlate },
  ]},
  { section: "Localize & Distribute", items: [
    { to: "/localization", label: "Localization", icon: Translate },
    { to: "/shorts", label: "Shorts Factory", icon: Scissors },
    { to: "/thumbnails", label: "Thumbnail Studio", icon: ImageIcon },
    { to: "/music", label: "Music & SFX", icon: MusicNotes },
    { to: "/sonic", label: "Sonic Identity", icon: WaveSine },
    { to: "/social", label: "Social Hub", icon: ShareNetwork },
    { to: "/publisher", label: "Publishing Queue", icon: PaperPlaneTilt },
    { to: "/calendar", label: "Content Calendar", icon: CalendarBlank },
  ]},
  { section: "Insights", items: [
    { to: "/analytics", label: "Analytics", icon: ChartLineUp },
    { to: "/hype-radar", label: "Hype Radar", icon: Radar },
    { to: "/growth", label: "Growth AI", icon: TrendUp },
    { to: "/revenue", label: "Revenue Centre", icon: CurrencyDollar },
    { to: "/costs", label: "AI Cost Control", icon: Gauge },
    { to: "/cost-dashboard", label: "AI Cost Dashboard", icon: TrendUp },
  ]},
  { section: "System", items: [
    { to: "/setup", label: "Setup Center", icon: HardDrives },
    { to: "/providers", label: "AI Providers", icon: Stack },
    { to: "/agents", label: "AI Agents", icon: Cpu },
    { to: "/local", label: "Local AI", icon: HardDrives },
    { to: "/local-lab", label: "Local Test Lab", icon: Flask },
    { to: "/safety", label: "Kids Safety", icon: ShieldCheck },
    { to: "/provenance", label: "Asset Provenance", icon: Fingerprint },
    { to: "/licensing", label: "Licensing", icon: Handshake },
    { to: "/merch", label: "Merch Studio", icon: Package },
    { to: "/users-access", label: "Users & Access", icon: UsersThree },
    { to: "/account", label: "My Account", icon: UserCircle },
    { to: "/audit", label: "Audit Log", icon: ListMagnifyingGlass },
    { to: "/trash", label: "Trash", icon: TrashSimple },
    { to: "/notifications", label: "Notifications", icon: BellRinging },
    { to: "/settings", label: "Settings", icon: Gear },
  ]},
];

export const MOBILE_NAV = [
  { to: "/", label: "Home", icon: House },
  { to: "/characters", label: "Create", icon: Sparkle },
  { to: "/episodes", label: "Episodes", icon: FilmSlate },
  { to: "/analytics", label: "Insights", icon: ChartLineUp },
];
